// Utility for generating localStorage keys for activity indices by course
export const getActiveActivityKey = (courseId) => `activeActivityIndex-${courseId}`;
